import { useEffect } from "react";
import { useSiteContent } from "@/lib/hooks";

export const LAST_UPDATED = "17 October 2026";

export function useCompany() {
  const { data: c } = useSiteContent();
  return {
    name: c?.company_name || "Speedex International",
    number: c?.company_number || "[Company number]",
    office: c?.registered_office || "[Registered office address]",
    email: c?.contact_email || "[Contact email]",
    phone: c?.contact_phone || "[Contact phone]",
  };
}

export const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display font-bold text-slate-900 text-lg">{title}</h2>
    <div className="mt-3 space-y-3 text-slate-600 leading-relaxed text-sm sm:text-base">{children}</div>
  </section>
);

export default function LegalPage({ title, testid, children }) {
  useEffect(() => {
    document.title = `${title} | Speedex International`;
    window.scrollTo(0, 0);
    const prev = document.title;
    return () => { document.title = prev; };
  }, [title]);
  return (
    <div data-testid={testid}>
      <section className="bg-slate-900 text-white">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14">
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight">{title}</h1>
          <p className="mt-3 text-slate-400 text-sm">Last updated: {LAST_UPDATED}</p>
        </div>
      </section>
      <article className="max-w-3xl mx-auto px-5 sm:px-8 py-10">{children}</article>
    </div>
  );
}
